import { Badge } from "@/components/ui/badge";
import { RegistrationStatus } from "@workspace/api-client-react";

export function StatusBadge({ status }: { status: RegistrationStatus }) {
  const config: Record<RegistrationStatus, { label: string; variant: "default" | "secondary" | "destructive" | "outline", className?: string }> = {
    [RegistrationStatus.draft]: { label: "Draft", variant: "secondary" },
    [RegistrationStatus.sent]: { label: "Sent", variant: "outline", className: "bg-cyan-50 text-cyan-800 border-cyan-200 dark:bg-cyan-950 dark:text-cyan-300 dark:border-cyan-800" },
    [RegistrationStatus.accepted]: { label: "Accepted", variant: "default", className: "bg-emerald-500 hover:bg-emerald-600 text-white" },
    [RegistrationStatus.bid]: { label: "Bid Received", variant: "default", className: "bg-[hsl(187,64%,43%)] hover:bg-[hsl(187,64%,38%)] text-white" },
    [RegistrationStatus.no_bid]: { label: "No Bid", variant: "secondary", className: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300" },
    [RegistrationStatus.more_info]: { label: "Needs Info", variant: "outline", className: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800" },
    [RegistrationStatus.expired]: { label: "Expired", variant: "secondary" },
    [RegistrationStatus.failed]: { label: "Failed", variant: "destructive" },
    [RegistrationStatus.duplicate_skipped]: { label: "Skipped (duplicate)", variant: "secondary" },
  };

  const { label, variant, className } = config[status] || { label: status, variant: "outline" };

  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
}
